import { coreAPI } from './axiosClient';

export const getChannelList = () => {
  return coreAPI({
    method: 'GET',
    url: 'marketplace/integration-status',
  });
};

export const getWarehouseList = (value) => {
  return coreAPI({
    method: 'GET',
    url: `location/warehouse-list/?store_id=${value}&page=1&pageSize=25&sortBy=warehouse_name&sortDirection=asc&q=`,
  });
};

export const getStoreLocations = ({ locationId, isTokopediaBindTts }) => {
  return coreAPI({
    method: 'GET',
    url: 'store-locations/getStore',
    params: {
      location_id: locationId,
      is_tokopedia_bind_tts: isTokopediaBindTts,
    },
  });
};